
<template>
<!--https://fireship.io/lessons/paypal-checkout-frontend/-->
<!-- https://stackoverflow.com/questions/56414640/paypal-checkout-javascript-with-smart-payment-buttons-create-order-problem-->
  <div>
    <div v-if="paidFor">
      <h3>Vielen Dank für deine großartige Unterstützung</h3>
    </div>
    <div v-if="error" style="color:red">
      <h3>Uhh. Leider ist ein Fehler aufgeteten. Bitte probiere es nocheinmal oder schreibe uns über das Kontaktformular an! Entschuldige und Danke</h3>
    </div>
    <div v-if="isSending">
      <h3><i class="icon solid fa-clock fa-3x"></i><br/>Einen Moment bitte. Deine Spende wird gerade abgewickelt. Schon einmal vielen Dank :-)</h3>
    </div>

    <div v-show="!isSending" class="buttonTransaction" @click="clicked=!clicked">Überweisung</div>
    <div  v-if="clicked &&!isSending" class="mb-2">
        <div>GlobalSocial-network e.V.</div>
        <div>Kreissparkasse Saalfeld / Rudolstadt</div>
        <div>IBAN: DE88 8305 0303 0011 0253 60</div>
        <div>BIC: HELADEF1SAR</div>

        <div>
            <a title="Bestätigung"  class="w-100 button primary checkpayment icon solid fa-check"  href="#" @click.prevent="notifyServerWithUeberweisung()">Ich bestätige meine Unterstützung</a>
        </div>

    </div>
    <div v-show="!isSending" ref="paypal"></div>
  </div>
</template>

<script>

export default {
    name: "Payments",
    props:{
        project:{
            type:Object
        },
        stream_id:{
            type:String
        },
        packageName:{
            type:String
        },
        price:{
            type:Number
        },
        name:{
            type:String
        },
        email:{
            type:String
        },
        adress:{
            type:String
        },
        quittung:{
            type:Boolean,
            default:false
        },
        shipping:{
            type:Boolean,
            default:false
        },
        anonym:{
            type:Boolean,
            default:false
        },
        streamUserName:{
            type:String
        }
    },
    watch:{
        
    },
    data: function() {
        return {
            isSending:false,
            loaded: false,
            paidFor: false,
            error:false,
            clicked:false
        };
    },
    mounted: function() {
        window.onload = ()=>{
            this.init();
        }
        /*
        console.log('paypal');
        const script = document.createElement("script");
        script.src =
        "https://www.paypal.com/sdk/js?client-id=AU12SApQjc_ajL-lppibTod0tlycuu8cbBgkxHXcqIfCR4crh9ae5lCCwU6CiJAV7eY0JEjES2BiPLeV";
        script.addEventListener("load", this.init);
        document.body.appendChild(script);
        */
    },
    methods: {
         getTimestamp(){
            let date=new Date();
            return date.toLocaleString();
        },

        notifyServerWithUeberweisung(){
            this.isSending=true;
            setTimeout(()=>{
                this.notifyServer("Überweisung");
                this.isSending=false;
            },3000)
            return true;
        },
        notifyServerWithPaypal(paypalData){
            return this.notifyServer("Paypal",paypalData);
        },
        notifyServer(type,paypalData){
            let price=(this.price)?this.price.toFixed(2):this.price;
            this.$store.dispatch('shops/donate',{
                "Time":this.getTimestamp(),
                "project_id":this.project.id
                ,"stream_id":this.stream_id
                ,"price":price
                ,"name":this.name
                ,"email":this.email
                ,"adress":this.adress
                ,"anonym":this.anonym
                ,"quittung":this.quittung
                ,"Warensendung":this.shipping
                ,"type":type
                ,"stream_name":this._.isString(this.streamUserName)?this.streamUserName.trim():''
            });

            this.$emit('donationSuccess');
            console.log(paypalData);
        },

        init() {
            if(!this.loaded){
                try{
                this.loaded = true;
                window.paypal
                    .Buttons({
                    createOrder: (data, actions) => {
                        console.log('createOrder');
                        this.isSending=true;
                        return actions.order.create({
                        purchase_units: [
                            {
                            description: `Projekt: ${this.project.id} Paket: ${this.packageName}`,
                            amount: {
                                currency_code: "EUR",
                                value: this.price/*,
                                breakdown:{
                                    item_total:this.price
                                }*/
                            }
                            /*invoice_id:this.project.id+'|'+this.packageName/*,
                            items:[{
                                name:this.project.title,
                                unit_amount:{
                                    currency_code: "EUR",
                                    value: this.price
                                },
                                quantity:'1',
                                description:`Projekt: ${this.project.title} Paket: ${this.packageName}`
                            }]*/
                            }
                        ]
                        });
                    },
                    onApprove: async (data, actions) => {
                        console.log('onApprove');
                        if(actions){
                            const order = await actions.order.capture();
                            console.log(order);
                        }
                        this.paidFor = true;
                        this.notifyServerWithPaypal(data);
                        this.isSending=false;
                        
                    },
                    onError: err => {
                        console.log('onError');
                        this.error=true;
                        this.isSending=false;
                        console.log(err);

                        //TODO loging here
                    }
                    })
                    .render(this.$refs.paypal);
                }catch(ex){
                    console.log('onException');
                    this.error=true;
                    this.isSending=false;
                    console.log(ex);
                }
            }
        }
    }
};
</script>
<style scoped>
.buttonTransaction{
    background-color: #eaeaea;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    padding: 0.5rem;
    margin-bottom: 1rem;
}
.buttonTransaction:hover {
    filter: brightness(0.95);
    -webkit-filter: brightness(0.95);
    -moz-filter: brightness(0.95);
    -ms-filter: brightness(0.95);
    -o-filter: brightness(0.95);
    cursor: pointer;
}
.checkpayment{
    background-color: #3ba927;
}
</style>